export const Login = "auth/login";
export const Logout = "auth/logout";